/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespBrowseHeader_searchBrowse$ref: FragmentReference;
export type SbRespBrowseHeader_searchBrowse = {|
  +pageType: ?string,
  +meta: ?{|
    +header: ?string
  |},
  +$refType: SbRespBrowseHeader_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespBrowseHeader_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1052d7445b20283363a3b56df0d1b5e1';
module.exports = node;
